// TODO: aov3-8283 fix circular dependency issue
// eslint-disable-next-line import/no-cycle
import { useScenariosStore } from '@/stores/scenarios';
import to from 'await-to-js';
import axios from 'axios';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useExtractsStore = defineStore('extracts', () => {
  const scenariosStore = useScenariosStore();

  // states
  const extracts = ref([]);
  const selectedStep = ref(null);
  const loading = ref(false);

  // Actions
  async function generateExtract(extract) {
    loading.value = true;
    const scenarioId = scenariosStore.selectedScenario._id;
    const [err] = await to(
      axios.post(`/api/extracts/scenario/${scenarioId}`, { ...extract, scenarioId })
    );
    if (err) throw new Error(err.message);
    loading.value = false;
  }

  async function generateFurnitureExtract(extract) {
    loading.value = true;
    const scenarioId = scenariosStore.selectedScenario._id;
    const [err] = await to(
      axios.post(`/api/extracts/scenario/${scenarioId}/furniture`, { ...extract, scenarioId })
    );
    if (err) throw new Error(err.message);
    loading.value = false;
  }

  async function generateStoreExecutionsExtracts(extract) {
    loading.value = true;
    const scenarioId = scenariosStore.selectedScenario._id;
    const [err] = await to(
      axios.post(`/api/extracts/scenario/${scenarioId}/store-execution`, {
        ...extract,
        scenarioId,
      })
    );
    if (err) throw new Error(err.message);
    loading.value = false;
  }

  async function fetchExtracts() {
    const scenarioId = scenariosStore.selectedScenario._id;
    loading.value = true;
    const [err, response] = await to(axios.get(`/api/extracts/scenario/${scenarioId}`));
    if (err) throw new Error(err.message);
    extracts.value = response.data;
    loading.value = false;
  }

  function setSelectedStep(value) {
    selectedStep.value = value;
  }

  async function deleteExtract(extractId) {
    loading.value = true;
    const [err, result] = await to(axios.delete(`/api/extracts/${extractId}`));
    loading.value = false;
    if (err) throw new Error(err.message);
    if (result.data && result.data.errors) {
      throw new Error(`Unable to delete extract: ${extractId}`);
    }
  }

  return {
    extracts,
    selectedStep,
    loading,
    generateExtract,
    generateFurnitureExtract,
    generateStoreExecutionsExtracts,
    fetchExtracts,
    setSelectedStep,
    deleteExtract,
  };
});
